<template>
	<div id="market_detail ">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="freeUserType" :bgtype="0"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='isshowWaterMark'>
				<div class="index_left_centerpage whitebox">
					<div class="chart-type oh">
						<div class="fl">
							<span v-for="(item, i) in chartTypeList" :key="i"
							:class="chartType == item.value ? 'active' : ''"
							@click="changeChartType(item)">{{ item.label }}</span>
						</div>
						<div class="deeseek-tips fr width"><i class="orgfont">让deepseek做{{this.baseInfo.title}}分析：</i> 
							<em class="curp" @click="goAIChart(1)">快速分析 >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>
							<em class="curp" @click="goAIChart(2)">深度分析 ></em> 
						</div>
					</div>
					
					<div class="mt-3 pb-3 download-position " style="min-height: 835px">
						<div @click="downloadPng" class="downloadPng"><i class="el-icon-download font-30 color-c4"
								title="保存为图片"></i></div>
						<div id="chart-download">
							<div id="baseInfoCharts" class="mt-6 baseInfoCharts"></div>
							<!-- <div v-show="chartType == 3" id="baseInfoChartsRadar" class="mt-6 baseInfoCharts"></div> -->
							<p class="widthPC-75 margin-x-auto">数据来源：中投顾问产业研究大脑</p>
						</div>
					</div>
				</div>
			</watermark>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import html2canvas from "html2canvas" 
export default {
	name: 'bureauStatisticsDetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	components: {
	},
	data() {
		return {
			title: '统计局数据详情页',
			userdata: {},
			pageType: 1,
			code: '',
			baseInfo: {},
			showTable: false,
			isshowWaterMark: false, //是否显示水印
			isShowFreeUserTips: false, //是否显示免费用户提示
			freeUserType: 2,
			dataType: 1,
			chartType: 1,
			chartTypeList: [
			{ label: '折柱混合', value: 1 }, 
			{ label: '折线', value: 2 }, 
			{ label: '弧线', value: 5 }, 
			{ label: '面积', value: 6 }, 
			{ label: '饼图', value: 3 }, 
			// { label: '雷达', value: 4 }
			],
			mychart: null,
		}
	},
	beforeCreate() { },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
		});
		this.userdata = this.getuseriformation();
		this.code = this.$route.query.code;
		this.pageType = this.$route.query.type;
		// this.dataType = this.$route.query.dataType;
	},

	mounted() {
		window.scrollTo(0, 0);
		window.addEventListener("scroll", this.handleScroll, true);
		this.getPageDetail();
	},
	methods: {
		goAIChart(model) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			//存储到本地存储，每次点击覆盖前面的数据
			let aistitle = '';
			if (this.pageType == 8) {
					aistitle = '分析'; //产品产量数据
			}else{
				aistitle = '分析'; //行业统计数据
			}
			let jsonData = {
				title: this.baseInfo.title + aistitle,
			};
			console.log(jsonData);
			localStorage.setItem('aiChatData', JSON.stringify(jsonData));
			this.routerblank('/aiChat?code='+this.code+'&model='+model+'&type=6');
		},
		// 切换图表类型
		changeChartType(item) {
			this.chartType = item.value;
			this.drawShape('baseInfoCharts', this.baseInfo.data, this.baseInfo.title, this.baseInfo.unit, 'show');
		},
		downloadPng() {
			let fileName = this.baseInfo.title;
			// 转换成canvas
			html2canvas(document.getElementById("chart-download")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = fileName + ".png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
		getPageDetail() {
			var that = this;
			this.bus.$emit("loading", true);
			this.$axios.get(this.$api.cyl.statsData.detail() + "?code=" + this.code + "&dataType=" + this.pageType).then(function (res) {
				if (res.data.success) {
					console.log(res);
					that.baseInfo = res.data.list[0] || [];
					document.title = that.baseInfo.title;
					that.$nextTick(() => {
						that.drawShape('baseInfoCharts', that.baseInfo.data, that.baseInfo.title, that.baseInfo.unit, 'show');
					})
					// that.getPageDetail2(that.baseInfo.notionCode);
					that.bus.$emit("loading", false);
				} else {

				}
			})
		},


		drawShape(el, data, legendName, unit) {
			console.log(el, data, legendName, unit);
			let xAxisText = [];
			let barData = [], //柱状
				lineData = []; //折线
			for (var i = 0; i < data.length; i++) {
				let tempStr = '';
				// xAxisText.push(data[i].year);
				if (this.pageType == 1) { //1年度 3月度 4季度
					tempStr = data[i].year + "年";
					xAxisText.push(tempStr);
				} else if (this.pageType == 3) {
					tempStr = data[i].year + '-' + data[i].month + '月';
					xAxisText.push(tempStr);
				} else if (this.pageType == 4) {
					tempStr = data[i].year + '-' + data[i].quarter + '季度';
					xAxisText.push(tempStr);
				}else{
					xAxisText.push(data[i].year);
				}
				barData.push(data[i].value);
				lineData.push(data[i].growth);
			}
			//因为要从大到小按年份提取10条数据，所以前面按照从大到小排序了，但是柱状图又要从小到大排序，所以这里反转一下数据

			// 反转数据年份从小到大排序
			xAxisText.reverse();
			barData.reverse();
			lineData.reverse();
			if (this.chartType == 3) {
				this.$nextTick(() => {
				
				this.pieCharts(el, data, unit);
					
				})
				

			} else if (this.chartType == 1 || this.chartType == 2) {
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit,false,0);
				
			}else if(this.chartType == 4){
				this.radarChart(el, data,unit);

			}else if(this.chartType == 5){			
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit,true,0);
			}else if(this.chartType == 6){			
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit,false,.5);
			}
		},

/**
 * Configures and renders a chart using ECharts.
 * 
 * @param {string} el - dom 元素.
 * @param {Array} xdata - 横轴数据
 * @param {Array} lineData - 折线图数据
 * @param {Array} barData - 柱状图数据
 * @param {string} legendName - 图标名称
 * @param {string} unit - 单位
 * @param {boolean} smooth - 是否平滑折线图
 * @param {string} areaStyleOpacity - 面积图的透明度
 * -
 */
		cpclChart(el, xdata, lineData, barData, legendName, unit,smooth,areaStyleOpacity) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let min = Math.floor(Math.min(...barData));
			let max = Math.floor(Math.max(...barData));
			let lineMin = Math.floor(Math.min(...lineData));
			let lineMax = Math.floor(Math.max(...lineData));
			let range = max - min;
			let chartType1 = 'bar';
			let chartType2 = 'line';
			if (this.chartType == 2 || this.chartType ==5 ||this.chartType ==6) {
				chartType1 = 'line';
				chartType2 = 'line';
			} else if (this.chartType == 3) {
				chartType1 = 'pie';
				chartType2 = 'pie';
			} else if (this.chartType == 4) {

			}

			min = min - (range / 1)
			// console.log(min,max,range);
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					grid: {
						top: '20%',
					},
					// confine:true, //是否将提示框限制在图表的区域内
					appendToBody: true, //是否将提示框放置在body元素上
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var name = params[0].name + "</br>";
						var dotHtml = '', dotHtml2 = '', unitd =  unit;
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unitd + "</br>"; // 定义第一个数据前的圆点颜色	
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result
					},
				},
				legend: {
					show: true,
					bottom: "10",
					itemGap: 30,

				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
					// axisLabel: { color: '#333', interval: 0, rotate: 50 }
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						minInterval: 1,
						min: min,
						boundaryGap: false,
						// step:
						axisTick: {
							"show": true
						},
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						splitLine: {
							show: true
						}, //不显示分割线
					},
					{
						type: 'value',
						name: ' ',
						min: lineMin,
						boundaryGap: false,
						axisTick: {
							"show": true
						},
						splitLine: {
							show: false
						}, //不显示分割线
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						axisLabel: {
							// 使用 formatter 属性来格式化标签文本
							formatter: '{value} %' // 在这里添加单位
						}
					}
				],
				series: [
					{
						type: chartType1,
						name: legendName,
						color: 'rgb(96, 147, 218)',
						yAxisIndex: 0, // 这里指定使用第一个 Y 轴
						data: barData,
						barMaxWidth: 30,
						smooth: smooth,
						areaStyle: {opacity:areaStyleOpacity},
						label: {
							show: true,
							// 绝对的像素值,避免折线数据和柱状数据重叠
							position: [0, -30],
							// position: 'auto',
							formatter: '{c}' + unit,
						}
					},
					{
						name: 'YOY',
						type: chartType2,
						yAxisIndex: 1,
						color: '#ffaf25',
						data: lineData,
						smooth: smooth,
						areaStyle: {opacity:areaStyleOpacity},
						label: {
							show: true,
							position: 'auto',
							formatter: '{c}%'
						}
					}
				]
			}
			this.mychart.setOption(option);

		},
		radarChart(el, data,unit) {
			unit = unit ? unit : '';
			 this.mychart = echarts.init(document.getElementById(el));
			 this.mychart.clear();
			 let _this = this;
			 let seriesData1 = [], seriesData2 = [];
			for (var i = 0; i < data.length; i++) {
				let tempStr = '';
				if (this.pageType == 1) { //1年度 3月度 4季度
					tempStr = data[i].year + "年";
				} else if (this.pageType == 3) {
					tempStr = data[i].year + '-' + data[i].month + '月';
				} else if (this.pageType == 4) {
					tempStr = data[i].year + '-' + data[i].quarter + '季度';
				}else {
					tempStr = data[i].year;
				}
				console.log('------',tempStr);
				data[i].name = tempStr;
				seriesData1.push(data[i].value);
				seriesData2.push(data[i].growth);
			}
			const option = {
				title: {
					text: this.baseInfo.title,
					left: 'center',
				},
				legend: {
					data: [this.baseInfo.title, 'YOY'],
					bottom: 10
				},
				tooltip: {
					show: true
				},
				radar: {
					// shape: 'circle',
					indicator: data,
				},
				series: [
					{
						name: '123213',
						type: 'radar',
						data: [
							{
								value: seriesData1,
								name: _this.baseInfo.title,
								lineStyle: {
									type: 'dashed'
								},
								 
							},
							{
								value: seriesData2,
								name: 'YOY',
								// lineStyle: {
									// color: '#ffaf25'
								// },
								// tooltip: {
								// 	show: true,
								// 	formatter: function (params) {
								// 		return 'YOY :' + params.value + '%';
								// 	}
								// }
							}
						]
					}
				]
			};
			this.mychart.setOption(option)

		},
		pieCharts(el, data, unit, type) {
			console.log(el, data);
			unit = unit ? unit : ''
			let _this = this;
			let seriesData = [];
			let temGrid = { top: '20%', bottom: '10%' };
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			for (var i = 0; i < data.length; i++) {
				let tempStr = '';
				if (this.pageType == 1) { //1年度 3月度 4季度
					tempStr = data[i].year + "年";
				} else if (this.pageType == 3) {
					tempStr = data[i].year + '-' + data[i].month + '月';
				} else if (this.pageType == 4) {
					tempStr = data[i].year + '-' + data[i].quarter + '季度';
				}else {
					tempStr = data[i].year;
				}
				data[i].name = tempStr;
				data[i].value = data[i].value;
			}
			seriesData = data;
			var option = {
				tooltip: {
					trigger: 'item',

					formatter:function(params){
						// console.log(params);
						return params.name+'</br>'+_this.baseInfo.title+' : '+ params.value + unit+'</br>'+'占比 : '+params.percent+'%'+'</br>'+'YOY : '+params.data.growth+'%';
					}
						
				},
				grid: temGrid,
				title: {
					show:  true ,
					text: _this.baseInfo.title,
					left: 'center',
					top: 10,
					textStyle: {
						fontSize: 20,
					}
				},
				toolbox: { //可视化的工具箱
					show: false,
					itemGap: 30,
					itemSize: 20,
					right: '9%',
					feature: {
						dataView: { //数据视图
							show: false,
							title: '数据视图',
						},
						saveAsImage: {//保存图片
							show: type == 'show' ? true : false,
							title: '保存为图片'
						},
					}
				},
				series: [
					{
						name: '',
						type: 'pie',
						avoidLabelOverlap: false,
						label: {
							show:true,
							position: 'outside',
							formatter: '{b}',
							// fontSize: 16
						},
						 
						labelLayout: {
							hideOverlap: false // 是否隐藏重叠标签
						},
						minAngle: 15, //最小角度
						// startAngle: 270, //起始角度
						data: seriesData,
						itemStyle: {
							normal: {
								borderColor: '#ffffff', // 发光颜色
								// borderWidth: 5,       // 发光宽度
								// shadowBlur: 10,       // 阴影模糊大小
								// shadowColor: '#f7f3ff'  // 阴影颜色
							}
						},
					}
				],
			};
			this.mychart.setOption(option);
		 
		},
		//length 每行显示长度
		getEqualNewlineString(params, length) {
			let text = ''
			let count = Math.ceil(params.length / length) // 向上取整数
			// 一行展示length个
			if (count > 1) {
				for (let z = 1; z <= count; z++) {
					text += params.substr((z - 1) * length, length)
					if (z < count) {
						text += '\n'
					}
				}
			} else {
				text += params.substr(0, length)
			}
			return text
		},
		// dmo元素里的内容转换为canvas,并将canvas下载为图片
		download() {
			// 转换成canvas
			html2canvas(document.getElementById("baseInfoCharts")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = "图表.png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
	}
}
</script>

<style>
.market-list {
	width: calc(33% - 35px);
	height: 365px;
	cursor: pointer;
	overflow: hidden;
	transition: all .3s;
	border: 1px solid #eee;
	margin-right: 35px;
	border-radius: 8px;
}

.market-title {
	padding: 20px 20px 0 20px;
	height: 48px;
}

.baseInfoCharts {
	width: 95%;
	height: 700px;
	/* border: 1px solid red; */
	margin: 0 auto;
}

.market-chain-img {
	width: 95%;
	margin: 0 auto;
	padding-bottom: 10px;
}

.download-position {
	position: relative;

}

.download-position .downloadPng {
	cursor: pointer;
	position: absolute;
	right: 11%;
	top: 25px;
	z-index: 99;
}
</style>